import React from 'react';
import fffLogo from '../../../assets/fff-logo.svg';
import styles from './LogoHeader.module.css';

const LogoHeader = () => (
  <div className={styles.header}>
    <img
      src={fffLogo}
      alt="logo"
      className={styles.fffLogo}
      data-testid="fff-logo"
    />
  </div>
);

export default LogoHeader;
